import * as Network$dJsonRPC from "../Network.JsonRPC/index.js";
import * as Restaumatic$dGeocoding$dRPC$dSites$dTypes from "../Restaumatic.Geocoding.RPC.Sites.Types/index.js";
import * as Restaumatic$dSite$dRPC from "../Restaumatic.Site.RPC/index.js";
const reverseGeocode = restaurantId => coordinates => Restaumatic$dSite$dRPC.sitesRPC(Network$dJsonRPC.encodeRequest(Restaumatic$dGeocoding$dRPC$dSites$dTypes.encodeReverseGeocodeRequest)({
  encodeWithOptions: v => Restaumatic$dGeocoding$dRPC$dSites$dTypes.encodeReverseGeocodeRequest.encode
}))(Network$dJsonRPC.decodeResponse(Restaumatic$dGeocoding$dRPC$dSites$dTypes.decodeReverseGeocodeResponse))(Restaumatic$dGeocoding$dRPC$dSites$dTypes.rpcMethodNameReverseGeocodeRequest)({
  coordinates,
  restaurantId
});
export {reverseGeocode};
